<ms-label>{{value}}</ms-label>
